/*
 * @Author: Han
 * @Date: 2021-12-01 18:00:45
 * @LastEditors: Han
 * @LastEditTime: 2021-12-13 09:49:15
 * @FilePath: \console\console\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import 'es6-promise/auto'
import Vue from 'vue'
import router from '@/router'
import store from '@/store/index'
// import ajax from '@/libs/ajax'
import '@/assets/css/reset.css'
import elementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'font-awesome/css/font-awesome.min.css'
Vue.config.productionTip = false
import api from './http/index'
import MenuUtils from './utils/MenuUtils'
import 'default-passive-events'
import VueMousetrapPlugin from 'vue-mousetrap/vue2'
Vue.use(VueMousetrapPlugin)
// import VueRouter from 'vue-router'
// Vue.use(VueRouter)
// import defaultRoutes from "./router/route.js";

Vue.use(api)
const defaultRoutes = JSON.parse(sessionStorage.getItem("defaultRoutes"))
if (defaultRoutes) {
  let datas = []
  MenuUtils(datas, defaultRoutes)
  router.addRoutes(datas)
}
router.beforeEach((to, from, next) => {
  const token = sessionStorage.getItem("token")
  if (token) {
    if (to.path == '/') {
      next('/login')
    } else {
      if (to.name == null) {
        next('/404')
      } else {
        next()
      }
    }
  } else {
    if (to.path == '/login') {
      next()
    } else {
      next('/login')
    }
  }
})

Vue.use(elementUI)
const mixin = {
  data() {
    return {
      dialogVisible: true,
      rowType: sessionStorage.getItem('roleType') || null
    }
  }
}
Vue.mixin(mixin)
try {
  new Vue({
    el: '#app',
    router,
    store,
    template: '<router-view></router-view>'
  })
} catch(e) {

}




// WEBPACK FOOTER //
// ./src/main.js